"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolvers = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

// typescript import
// definition
var resolvers = {
  Mutation: {
    logout: function () {
      var _logout = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_, __, _ref) {
        var client, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                client = _ref.client;
                _context.next = 3;
                return fetch('/api/auth/logout', {
                  method: 'post',
                  credentials: 'same-origin'
                });

              case 3:
                res = _context.sent;

                if (!(res.status !== 200)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", {
                  __typename: 'LogoutResponse',
                  status: 'FAIL'
                });

              case 6:
                _context.next = 8;
                return client.resetStore();

              case 8:
                if (typeof window !== 'undefined') {
                  window.sessionStorage.clear();
                  window.localStorage.removeItem('shipment');
                  window.localStorage.removeItem('products');
                }

                return _context.abrupt("return", {
                  __typename: 'LogoutResponse',
                  status: 'OK'
                });

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function logout(_x, _x2, _x3) {
        return _logout.apply(this, arguments);
      }

      return logout;
    }()
  }
};
exports.resolvers = resolvers;